import classNames from 'classnames';

import { FC } from 'react';

import { Image } from '../Image/Image';
import styles from './BadgeIllustration.module.scss';
import { BADGE } from './BadgeIllustration.type';

interface Props {
  icon: BADGE | string;
  background: 'none' | 'gradient';
  shape: 'circle' | 'square';
  className?: string;
}

export const BadgeIllustration: FC<Props> = ({ icon, background, shape, className }) => (
  <div
    className={classNames(styles.root, className, {
      [styles.gradient]: background === 'gradient',
      [styles.circle]: shape === 'circle',
      [styles.square]: shape === 'square',
    })}
  >
    <Image src={icon} width={100} height={100} alt="" className={styles.illustration} />
  </div>
);
